import { Box, CircularProgress, Collapse, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import colors from '../../styles/colors';
import dayjs from 'dayjs';
import { EmailProcessTypes } from './RecruitmentHelper';
import globalStyles from '../../utilities/styles';
import Header from '../../components/web/header';
import SubHeader from '../../components/web/subHeader';
import messages from '../../utilities/messages';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const radioButtonStyle = {
  '&.Mui-checked': {
    color: colors.primary,
  }
}

const OpportunitiesList = ({ isNotificationUpdated, frequency, setFrequency, setCurrentProcess, updateNotificationStatus }) => {
  const toastSubtitle = frequency === 'none' ? messages.toastMessages.subTitleNone : messages.toastMessages.subTitle;
  // const [opportunityTrackingInfo, setOpportunityTrackingInfo] = useState([]);

  // const addOpportunity = () => {
  //   setOpportunityTrackingInfo([
  //     ...opportunityTrackingInfo,
  //     { opportunity: '', frequency: 'hourly', watchers: [''] },
  //   ]);
  // };

  // const handleOpportunityChange = (index, key, value) => {
  //   const newOpportunities = [...availableOpportunities];
  //   newOpportunities[index][key] = value;
  //   setAvailableOpportunities(newOpportunities);
  // };

  // const handleWatchersChange = (index, watcherIndex, value) => {
  //   const newOpportunities = [...opportunityTrackingInfo];
  //   newOpportunities[index].watchers[watcherIndex] = value;
  //   setOpportunityTrackingInfo(newOpportunities);
  // };

  // const addWatcher = (index) => {
  //   const newOpportunities = [...opportunityTrackingInfo];
  //   newOpportunities[index].watchers.push('');
  //   setOpportunityTrackingInfo(newOpportunities);
  // };

  // const OpportunityList = ({ index, frequency, opportunityTitle, createdDate, title }) => {
  //   const createdAt = dayjs(createdDate).format('MMMM DD, YYYY HH:MMa')

  //   return (
  //     <Paper
  //       elevation={2}
  //       sx={{
  //         p: '10px', mt: '20px', border: 1, borderRadius: 4,
  //         width: '100%', alignSelf: 'center',
  //         borderColor: frequency === '' ? colors.primary : colors.black
  //       }}>
  //       <Stack
  //         direction="row"
  //         spacing={2}
  //         sx={{
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //         }}
  //       >
  //         <Box display={'flex'} flexDirection={'row'}>
  //           {frequency === '' && <Box
  //             sx={{
  //               width: 13,
  //               height: 13,
  //               mt: '5px',
  //               mr: '5px',
  //               borderRadius: 6,
  //               backgroundColor: colors.primary
  //             }}
  //           />}
  //           <Stack>
  //             <Typography variant="body1" component="div" sx={{ flexGrow: 1, fontWeight: '600' }}>
  //               {opportunityTitle}: {title}
  //             </Typography>
  //             <Typography variant="subtitle2" component="div" sx={{ flexGrow: 1, fontWeight: '500' }}>
  //               <b>Posted:</b> {createdAt}
  //             </Typography>
  //           </Stack>
  //         </Box>
  //         <FormControl
  //           size='small'
  //           sx={{
  //             minWidth: 300,
  //             borderRadius: 4,
  //             borderColor: colors.primary
  //           }}
  //         >
  //           <Select
  //             margin="dense"
  //             displayEmpty
  //             labelId="select-company"
  //             id="select-company"
  //             value={frequency}
  //             renderValue={(selected, index) => {
  //               if (selected && selected.length === 0) {
  //                 return <em>Email Frequency</em>;
  //               }

  //               return selected;
  //             }}
  //             onChange={(e) => handleOpportunityChange(index, 'frequency', e.target.value)}
  //           >
  //             <MenuItem value={'hourly'}>Hourly</MenuItem>
  //             <MenuItem value={'daily'}>Daily</MenuItem>
  //             <MenuItem value={'weekly'}>Weekly</MenuItem>
  //           </Select>
  //         </FormControl>
  //       </Stack>
  //     </Paper>
  //   );
  // }

  const toastMessage = (
    <Paper sx={{ width: '100%', height: 80, backgroundColor: '#DFF1E8' }} elevation={1}>
      <Box sx={{
        textAlign: 'center'
      }}>
        <Stack sx={{ pt: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <CheckCircleIcon color={'success'} />
          <Typography variant='body1' fontWeight={'600'} ml={'10px'} >{messages.toastMessages.title}</Typography>
        </Stack>
        <Typography variant='body2'>{toastSubtitle}</Typography>
      </Box>
    </Paper>
  );

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <Header
          showBackButton
          onBackClick={() => setCurrentProcess(EmailProcessTypes.COMPANY)}
          title={messages.headerTitles.opportunityNotifications} />
        <Collapse
          in={isNotificationUpdated}
          timeout={500}
        >{toastMessage}</Collapse>
        <SubHeader
          title={'Set Opportunity Notification Frequency'}
          subTitle={'Select your preferred email frequency to receive opportunity applications. Reports will be sent to person@ukg.com.'}
        />

        <Stack sx={{ width: globalStyles.fieldWidth, alignSelf: 'center' }}>
          {/* {
            opportunitiesNotifications.length > 0 &&
            opportunitiesNotifications.map((opportunity, index) => {

              return (
                <OpportunityList
                  key={index}
                  index={index}
                  frequency={opportunity.frequency}
                  createdDate={opportunity.createdAt}
                  opportunityTitle={opportunity.opportunity}
                  title={opportunity.title}
                />
              )
            })
          } */}
          <RadioGroup
            defaultValue={frequency}
            value={frequency}
            onChange={(e) => {
              setFrequency(e.target.value);
              updateNotificationStatus(e.target.value)
            }}
          >
            <FormControlLabel value="daily" control={<Radio sx={radioButtonStyle} />} label="Daily" />
            <FormControlLabel value="weekly" control={<Radio sx={radioButtonStyle} />} label="Weekly" />
            <FormControlLabel value="monthly" control={<Radio sx={radioButtonStyle} />} label="Monthly" />
            <FormControlLabel value="none" control={<Radio sx={radioButtonStyle} />} label="None" />
          </RadioGroup>
        </Stack>
      </Box>
    </>
  );
  // return (

  //   <div>
  //     <h3>Opportunities List</h3>
  //     {opportunityTrackingInfo.map((opportunity, index) => (
  //       <div key={index}>
  //         <label>Opportunity: </label>
  //         <select
  //           value={opportunity.opportunity}
  //           onChange={(e) =>
  //             handleOpportunityChange(index, 'opportunity', e.target.value)
  //           }
  //         >
  //           <option value="">Select Opportunity</option>
  //           {availableOpportunities.map((op, i) => (
  //             <option key={i} value={op}>
  //               {op}
  //             </option>
  //           ))}
  //         </select>

  //         <label> Frequency: </label>
  //         <select
  //           value={opportunity.frequency}
  //           onChange={(e) =>
  //             handleOpportunityChange(index, 'frequency', e.target.value)
  //           }
  //         >
  //           <option value="hourly">Hourly</option>
  //           <option value="daily">Daily</option>
  //         </select>

  //         <label> Watchers: </label>
  //         {opportunity.watchers.map((watcher, watcherIndex) => (
  //           <input
  //             key={watcherIndex}
  //             type="text"
  //             value={watcher}
  //             onChange={(e) =>
  //               handleWatchersChange(index, watcherIndex, e.target.value)
  //             }
  //             placeholder="Enter watcher email"
  //           />
  //         ))}
  //         <button onClick={() => addWatcher(index)}>Add Watcher</button>

  //         <hr />
  //       </div>
  //     ))}

  //     <button onClick={addOpportunity}>Add New Opportunity</button>
  //   </div>
  // );
};

export default OpportunitiesList;
